module.exports = {
    builderTypes: {
        2: "Auxiliary Business",
        3: "Builder",
        4: "Corporate Officer",
        5: "Employee or Independent Contractor",
        6: "Organ Supplier",
        7: "Professional Association",
        8: "Service Person",
        0: "Unknown",
        1: "Other"
    },
    imageTypes: {
        2: "Facade",
        3: "Console",
        4: "Pipework",
        5: "Chamber/Mechanism",
        6: "Blower",
        7: "Room",
        8: "Building Exterior",
        9: "Builder",
        0: "Unknown", 
        1: "Other"
    },
    keyActionTypes: {
        2: "Electrical",
        3: "Mechanical (Details Unknown)",
        4: "Mechanical (Balanced Tracker)",
        5: "Mechanical (Suspended Tracker)",
        6: "Mechanical (Sticker)",
        7: "Mechanical (Multiple Types)",
        8: "Mechanical With Pneumatic Assists",
        9: "Tubular Pneumatic (Details Unknown)",
        10: "Tubular Pneumatic (Pressure)",
        11: "Tubular Pneumatic (Vacuum)",
        12: "Multiple Action Types",
        0: "Unknown",
        1: "Other"
    },
    stopActionTypes: {
        2: "Electrical",
        3: "Mechanical",
        4: "Mechanical With Pneumatic Assists",
        5: "Tubular Pneumatic (Details Unknown)",
        6: "Tubular Pneumatic (Pressure)",
        7: "Tubular Pneumatic (Vacuum)",
        8: "Multiple Action Types",
        9: "No Stop Action",
        0: "Unknown",
        1: "Other"
    },
    stopLayoutTypes: {
        2: "Drawknobs",
        3: "Drawknobs in Vertical Rows on Angled Jambs",
        4: "Drawknobs in Vertical Rows on Flat Jambs",
        5: "Drawknobs in Horizontal Row Above Top Manual",
        6: "Drawknobs in Horizontal Rows on Terraced/Stepped Jambs",
        7: "Drawknobs in Horizontal Rows on Angled Jambs",
        8: "Drawknobs in Horizontal Rows on Flat Jambs",
        9: "Drawknobs in Horizontal Rows on Curved Jambs",
        10: "Tilting/Rocking Tablets",
        11: "Tilting/Rocking Tablets Above Top Manual",
        12: "Tilting/Rocking Tablets on Angled Jambs",
        13: "Tilting/Rocking Tablets on Slanted Jambs",
        14: "Tilting/Rocking Tablets on Horizontal Curved Jambs",
        15: "Stop Keys",
        16: "Stop Keys Above Top Manual",
        17: "Stop Keys on Angled Jambs",
        18: "Stop Keys in Horseshoe Curves",
        19: "Push-Button Stop Controls/Luminous Pistons",
        20: "Sliding Stop Controls/Levers",
        21: "Haskell Style Stop-Keys/Keyboard",
        22: "No Stop Controls",
        0: "Unknown",
        1: "Other"
    },
    pedalTypes: {
        2: "Concave Radiating (Details Unknown)",
        3: "Concave Radiating (Meeting AGO Standards)",
        4: "Concave Radiating (Not Meeting AGO Standards)",
        5: "Concave Straight",
        6: "Flat Radiating",
        7: "Flat Straight",
        8: "No Pedalboard",
        0: "Unknown",
        1: "Other"
    },
    combinationActionTypes: {
        2: "Computerized/Digital",
        3: "Adjustable Combination Pistons",
        4: "Remote Pneumatic/Mechanical Capture",
        5: "'Hold and Set' Pneumatic/Mechanical",
        6: "Setterboard",
        7: "Adjustable Mechanical",
        8: "Fixed Mechanical",
        9: "Ventils",
        10: "Freie Kombinationen",
        11: "Blind Action",
        12: "None",
        0: "Unknown",
        1: "Other"
    },
    consoleTypes: {
        2: "Traditional With Roll Top",
        3: "Traditional Without Cover",
        4: "Traditional With Hinged Doors That Enclose Keyboards",
        5: "Traditional With Sliding Doors That Enclose Keyboards",
        6: "Traditional With a Removable Panel in Front of Keyboards",
        7: "Traditional With a Keyboard Cover That Can Be Lifted To Form a Music Rack",
        8: "Non-Traditional Style, As Consoles by Holtkamp, Schlicker, et al",
        9: "Horseshoe",
        0: "Unknown",
        1: "Other"
    },
    divisionPositionTypes: {
        2: "In a Case at the Front of the Room",
        24: "In Ceiling Chambers. No Visible Pipes",
        3: "In Center Chambers at the Front of the Room. No Visible Pipes",
        4: "In Side Chambers at the Front of the Room. No Visible Pipes",
        5: "In Center Chambers at the Front of the Room. Facade Pipes or Case Front Visible",
        6: "In Side Chambers at the Front of the Room. Facade Pipes or Case Front Visible",
        7: "In Side Chambers at the Front of the Room. Exposed Pipes Visible",
        8: "In a Case in a Side Transept",
        9: "In a Chamber in a Side Transept. No Visible Pipes",
        10: "In a Chamber in a Side Transept. Facade Pipes or Case Front Visible",
        11: "In a Chamber Beneath the Floor",
        12: "Pipes Exposed (in Whole or in Part) at the Front of the Room",
        13: "In a Floor-Level Case at the Rear of the Room",
        14: "In a Gallery-Level Case at the Rear of the Room",
        15: "In Floor-Level Chambers at the Rear of the Room",
        16: "In Gallery-Level Chambers at the Rear of the Room",
        17: "Pipes Exposed (in Whole or in Part) at Floor Level at the Rear of the Room",
        18: "Pipes Exposed (in Whole or in Part) in a Gallery at the Rear of the Room",
        19: "Exposed Pipes or Case Front Visible in a Gallery at the Rear of the Room",
        25: "Pipes Exposed on the Front Wall",
        26: "Pipes Exposed on the Rear Wall",
        27: "Pipes Exposed on the Side Wall",
        20: "Portable Instrument, Fully Movable",
        21: "Fully Digital Division, Speakers Not Visible",
        22: "Fully Digital Division, Speakers Visible",
        23: "Fully Digital Division, Speakers Inside False Facade",
        0: "Unknown",
        1: "Other"
    },
    divisionChestActionTypes: {
        2: "Slider (Details Unknown)",
        20: "Slider With Mechanical Pull-Downs",
        21: "Slider With Mechanical Stickers",
        3: "Slider With Pneumatic Pull-Downs (Externally, EP or TP)",
        4: "Slider With Direct-Electric Pull-Downs (Externally Mounted)",
        5: "Slider With Electro Pneumatic Pallets (Blackinton Type)",
        6: "Slider With Direct Electric Pallets (Internally Mounted)",
        7: "Ventil (Details Unknown)",
        8: "Ventil (Electro Pneumatic)",
        9: "Ventil (Tubular Pneumatic)",
        10: "Electro Pneumatic (Details Unknown)",
        11: "Electro Pneumatic (Pitman)",
        12: "Electro Pneumatic (Unit)",
        13: "Austin Universal Air",
        14: "Wurlitzer",
        15: "Direct Electric (Details Unknown)",
        16: "Direct Electric (Wicks)",
        17: "Pneumatic",
        18: "Spring",
        19: "Membrane",
        0: "Unknown",
        1: "Other"
    },
    divisionStopActionTypes: {
        2: "Electric",
        3: "Pneumatic (Details Unknown)",
        4: "Pneumatic (Electro Pneumatic)",
        5: "Pneumatic (Tubular Pneumatic)",
        6: "Ventil (Details Unknown)",
        7: "Ventil (Electro Pneumatic)",
        8: "Ventil (Tubular Pneumatic)",
        9: "Solenoids",
        10: "Mechanical (Details Unknown)",
        11: "Mechanical (Slider)",
        12: "Multiple Action Types",
        0: "Unknown",
        1: "Other"
    },
    consolePositions: {
        2: "Keydesk Attached",
        3: "Keydesk Attached, Manuals Set Into Case",
        4: "Detached Keydesk (Mechanical Action)",
        5: "Detached, Reversed Keydesk (Mechanical Action)",
        6: "Console in Fixed Position, Center",
        7: "Console in Fixed Position, Left",
        8: "Console in Fixed Position, Right",
        9: "Movable Console",
        10: "Console on Lift",
        11: "Console on Lift, Movable",
        0: "Unknown",
        1: "Other"
    },
    expressionTypes: {
        2: "Balanced Expression Shoes/Pedals (Details Unknown)",
        3: "Balanced Expression Shoes/Pedals (Meeting AGO Standards)",
        4: "Balanced Expression Shoes/Pedals (Not Meeting AGO Standards)",
        5: "Trigger/Hitch-Down Expression",
        6: "No Enclosed Divisions",
        0: "Unknown",
        1: "Other"
    },
    siteTypes: {
        0: "Webpage",
        1: "Recording"
    },
    locationTypes: {
        0: "Church",
        1: "School",
        2: "Public Location",
        3: "Private Location",
        4: "Other"
    },
    locationSubtypes: {
        0: {"id": 0, "name": "Unknown", "type": 4},
        1: {"id": 1, "name": "African Methodist Episcopal", "type": 0},
        2: {"id": 2, "name": "Apostolic", "type": 0},
        3: {"id": 3, "name": "Armenian Apostolic", "type": 0},
        4: {"id": 4, "name": "Assembly of God", "type": 0},
        5: {"id": 5, "name": "Baptist", "type": 0},
        6: {"id": 6, "name": "Brethren", "type": 0},
        7: {"id": 7, "name": "Church of Christ", "type": 0},
        8: {"id": 8, "name": "Church of Christ, Scientist", "type": 0},
        9: {"id": 9, "name": "Church of God", "type": 0},
        10: {"id": 10, "name": "Church of Jesus Christ of Latter-Day Saints (Mormon)", "type": 0},
        11: {"id": 11, "name": "Church of Sweden", "type": 0},
        12: {"id": 12, "name": "Church of the Nazarene", "type": 0},
        13: {"id": 13, "name": "Undetermined Denomination", "type": 0},
        14: {"id": 14, "name": "Congregational", "type": 0},
        15: {"id": 15, "name": "Convent, Monastery, and the Like", "type": 0},
        16: {"id": 16, "name": "Disciples of Christ / Christian", "type": 0},
        17: {"id": 17, "name": "Dutch Reformed", "type": 0},
        18: {"id": 18, "name": "Episcopal/Anglican", "type": 0},
        19: {"id": 19, "name": "Evangelical and Reformed", "type": 0},
        20: {"id": 20, "name": "Evangelical Covenant", "type": 0},
        21: {"id": 21, "name": "Evangelical United Brethren", "type": 0},
        22: {"id": 22, "name": "Federated", "type": 0},
        23: {"id": 23, "name": "French Huguenot", "type": 0},
        24: {"id": 24, "name": "Friends (Quaker)", "type": 0},
        25: {"id": 25, "name": "Greek Orthodox", "type": 0},
        26: {"id": 26, "name": "High School, Preparatory School, or Academy", "type": 1},
        27: {"id": 27, "name": "Holy Apostolic Catholic Assyrian Church of the East", "type": 0},
        28: {"id": 28, "name": "Hungarian Reformed", "type": 0},
        29: {"id": 29, "name": "Interdenominational", "type": 0},
        30: {"id": 30, "name": "International Church of the Foursquare Gospel", "type": 0},
        31: {"id": 31, "name": "Jehovah's Witness", "type": 0},
        32: {"id": 32, "name": "Lutheran", "type": 0},
        33: {"id": 33, "name": "Mennonite", "type": 0},
        34: {"id": 34, "name": "Methodist", "type": 0},
        35: {"id": 35, "name": "Moravian / Unity of the Brethren", "type": 0},
        36: {"id": 36, "name": "Nondenominational", "type": 0},
        81: {"id": 81, "name": "Polish National Catholic Church", "type": 0},
        37: {"id": 37, "name": "Presbyterian", "type": 0},
        38: {"id": 38, "name": "Reformed (RCA, CRC, URC, PRC)", "type": 0},
        39: {"id": 39, "name": "Roman Catholic", "type": 0},
        40: {"id": 40, "name": "Scottish Rite", "type": 0},
        41: {"id": 41, "name": "Serbian Orthodox", "type": 0},
        42: {"id": 42, "name": "Seventh-day Adventist", "type": 0},
        43: {"id": 43, "name": "Swedenborgian", "type": 0},
        44: {"id": 44, "name": "Synagogue or other Jewish House of Worship", "type": 0},
        45: {"id": 45, "name": "Unitarian, Universalist, Unitarian-Universalist", "type": 0},
        46: {"id": 46, "name": "United Church of Canada", "type": 0},
        47: {"id": 47, "name": "United Churches of Christ (UCC)", "type": 0},
        48: {"id": 48, "name": "Unity", "type": 0},
        49: {"id": 49, "name": "College or University", "type": 1},
        50: {"id": 50, "name": "Conservatory or Independent Music School", "type": 1},
        51: {"id": 51, "name": "Independent Music Teacher Studio", "type": 1},
        52: {"id": 52, "name": "Seminary", "type": 1},
        53: {"id": 53, "name": "Amusement: Skating Rink, etc.", "type": 2},
        54: {"id": 54, "name": "Arena or Stadium", "type": 2},
        55: {"id": 55, "name": "Auditorium or Concert Hall", "type": 2},
        56: {"id": 56, "name": "Exhibition, Fair, or Other Commercial Exhibit", "type": 2},
        57: {"id": 57, "name": "Factory or Commercial Business, Not Retail", "type": 2},
        58: {"id": 58, "name": "Hotel", "type": 2},
        59: {"id": 59, "name": "Museum", "type": 2},
        60: {"id": 60, "name": "Restaurant", "type": 2},
        61: {"id": 61, "name": "Retail Store: Department Store, Music Store, etc.", "type": 2},
        62: {"id": 62, "name": "Showroom for Builder, Exhibitor, etc.", "type": 2},
        63: {"id": 63, "name": "Social Service", "type": 2},
        64: {"id": 64, "name": "Theatre, Cinema, or Movie House", "type": 2},
        65: {"id": 65, "name": "Builder's Factory", "type": 3},
        66: {"id": 66, "name": "Builder's Shop: Storage, Display, etc.", "type": 3},
        67: {"id": 67, "name": "Hospital, Retirement/Nursing Home, etc.", "type": 3},
        68: {"id": 68, "name": "Lodge and Club", "type": 3},
        69: {"id": 69, "name": "Military Installation: Fort, Post, etc.", "type": 3},
        70: {"id": 70, "name": "Mortuary, Funeral Home, or Cemetery Chapel", "type": 3},
        71: {"id": 71, "name": "Private Residence", "type": 3},
        72: {"id": 72, "name": "Radio, Television or Movie Studio", "type": 3},
        73: {"id": 73, "name": "Yacht or Other Ocean-Going Vessel", "type": 3},
        74: {"id": 74, "name": "Organ Built for Development Purposes", "type": 4},
        75: {"id": 75, "name": "Prison", "type": 2},
        76: {"id": 76, "name": "Train Station", "type": 2},
        77: {"id": 77, "name": "Airport", "type": 2},
        78: {"id": 78, "name": "City Square", "type": 2},
        79: {"id": 79, "name": "Mall", "type": 2},
        80: {"id": 80, "name": "Library", "type": 2}
    },
    biosHOLTypes: {
        0: "None",
        1: "Grade I",
        2: "Grade II*",
        3: "Grade II",
    },
    temperamentTypes: {
        2: "Equal",
        3: "Fisk I",
        4: "Fisk II",
        5: "Kellner",
        6: "Kirnberger III",
        7: "Meantone",
        8: "Pythagorean",
        9: "Silbermann",
        10: "Vallotti",
        11: "Werckmeister I",
        12: "Werkmeister III",
        13: "Young I",
        14: "Young II",
        0: "Unknown",
        1: "Other",
    },
    editRequestCategoryTypes: {
        0: "Location",
        1: "Builder",
        2: "Instrument"
    },
    editRequestTypes: {
        0: "Details",
        1: "Image",
        2: "Document",
        3: "Note",
        4: "Webpage",
        5: "Stoplist",
        6: "Console",
        7: "Blower",
        8: "Reference",
    }
};